<script>
  import { createForm } from "svelte-forms-lib";
  import {Button, Col,Form,FormGroup,Input,InputGroup,InputGroupText,Label, Row} from "sveltestrap";
  import {City,FirstName,LastName,State,SubmitForm,TooltipValidation,TooltipValidationMessage,Username,Zip} from "../../../../utils/Constant/Constant";
  import Card from "../../../Core/Card.svelte";
  const { form, errors, state, handleChange, handleSubmit } = createForm({
    initialValues: {
      name: "",
      lName: "",
      city: "",
      state: "",
      zip: "",
      userName: "",
    },
    validate: (values) => {
      let errs = {};
      if (values.name === "") {
        errs["name"] = "Name is required";
      }
      if (values.lName === "") {
        errs["lName"] = "Last Name is required";
      }
      if (values.city === "") {
        errs["city"] = "City is required";
      }
      if (values.state === "") {
        errs["state"] = "State is required";
      }
      if (values.zip === "") {
        errs["zip"] = "Zip is required";
      }
      if (values.userName === "") {
        errs["userName"] = "User Name is required";
      }
      return errs;
    },
    onSubmit: (values) => {
      alert(JSON.stringify(values));
    },
  });
</script>

<Col sm="12" >
  <Card headerTitle={TooltipValidation} cardHeaderprops="pb-0">
    <div slot="customheader">
      <span>{@html TooltipValidationMessage}</span>
    </div>
    <div slot="contentbody">
      <Form
        class="row g-3 needs-validation tooltip-validation"
        on:submit={handleSubmit}
      >
        <Row>
          <Col md="4" class="position-relative">
            <Label>{FirstName}</Label>
            <Input
              name="name"
              type="text"
              placeholder="First name"
              on:change={handleChange}
              bind:value={$form.name}
            />
            {#if $errors.name}
              <div class="invalid-tooltip">{$errors.name}</div>
            {/if}
          </Col>
          <Col md="4" class="position-relative">
            <Label>{LastName}</Label>
            <Input
              name="lName"
              type="text"
              placeholder="Last name"
              on:change={handleChange}
              bind:value={$form.lName}
            />
            {#if $errors.lName}
              <div class="invalid-tooltip">{$errors.lName}</div>
            {/if}
          </Col>
          <Col md="4" class="position-relative">
            <Label>{Username}</Label>
            <InputGroup>
              <InputGroupText>@</InputGroupText>
              <Input
                name="userName"
                type="text"
                placeholder="Username"
                on:change={handleChange}
                bind:value={$form.userName}
              />
              {#if $errors.userName}
                <div class="invalid-tooltip">{$errors.userName}</div>
              {/if}
            </InputGroup>
          </Col>
          <Col md="6" class="position-relative">
            <Label>{City}</Label>
            <Input
              name="city"
              type="text"
              placeholder="City"
              on:change={handleChange}
              bind:value={$form.city}
            />
            {#if $errors.city}
              <div class="invalid-tooltip">{$errors.city}</div>
            {/if}
          </Col>
          <Col md="3" class="position-relative">
            <Label>{State}</Label>
            <Input
              type="select"
              name="select"
              bind:value={$form.state}
              placeholder="State"
              id="validationCustom04"
              on:change={handleChange}
            >
              <option>Choose...</option>
              <option>...</option>
            </Input>
            {#if $errors.state}
              <div class="invalid-tooltip">{$errors.state}</div>
            {/if}
          </Col>
          <Col md="3" class="position-relative">
            <Label>{Zip}</Label>
            <Input
              name="zip"
              type="text"
              placeholder="Zip"
              on:change={handleChange}
              bind:value={$form.zip}
            />
            {#if $errors.zip}
              <div class="invalid-tooltip">{$errors.zip}</div>
            {/if}
          </Col>
          <Col xs="12">
            <Button color="primary" type="submit" >{SubmitForm}</Button>
          </Col>
        </Row>
      </Form>
    </div>
  </Card>
</Col>
